import { cva } from "class-variance-authority"

export const inputFieldVariants = cva(
  `bg-input-field-dropdown-primary font-medium-400 text-general-primary-text file:text-general-primary-text placeholder:text-general-secondary-label disabled:bg-button-inactive disabled:text-general-secondary-label flex h-10 w-full rounded px-3 py-2 file:mr-2 file:border-0 file:border-r file:bg-transparent file:text-sm file:font-medium focus-visible:outline-2 disabled:cursor-not-allowed`,
  {
    variants: {
      error: {
        true: "outline-general-red outline outline-1",
      },
      success: {
        true: "outline-general-green outline outline-1",
      },
      v2: {
        true: `bg-interaction-field text-icon-general-primary placeholder:text-icon-general-secondary hover:bg-interaction-field-hovered focus-visible:bg-interaction-field-selected focus-visible:outline-semantic-interaction-selected disabled:text-icon-general-disabled disabled:placeholder:text-icon-general-disabled border-none transition-colors focus-visible:outline-1 focus-visible:outline-offset-0`,
      },
    },
  }
)
